import { Container } from 'pixi.js'
import gsap from 'gsap'

class MenuUtil {
  public menuPanelRef: Container
  public popUpRef: Container

  public menuPanelMove = (targetY: number, node: Container) => {
    // console.log('menuPanelMove', node);
    const task = gsap.to(node, {
      duration: 0.2,
      y: `${targetY}`,
      onComplete: () => {
        task.kill()
      },
    })
  }
}

export const menuUtil = new MenuUtil()
